import { AppPlatform } from "../graphql/queries/app.js";
import { SocialMedia } from "../graphql/queries/_common.js";

export const trackPageView = (
    title: string,
    pathname: string,
    search: string,
) => {
    if (typeof gtag === "function") {
        gtag("event", "page_view", {
            page_title: title,
            page_path: pathname + search,
            cpath: pathname,
        });
    }
};

const trackGA4Event = (
    eventName: string,
    params: {
        cpath: string;
        place?: string;
        to?: string;
        lbl?: string;
    },
) => {
    if (typeof gtag === "function") {
        gtag("event", eventName, params);
    }
};
const trackFBEvent = (
    action: string,
    label?: string,
    category: string = "engagement",
    value?: number,
) => {
    if (typeof fbq === "function") {
        fbq("trackCustom", category, {
            action,
            label,
            value,
        } as any);
    }
};

// export const gaLoadMoreData = () => {
//     trackGA4Event(`load_more_news`);
// };

export const gaNavClick = (
    linkName: string,
    place: "menu" | "page404" | "breadcrumbs" | "footer",
    cpath: string,
) => {
    trackGA4Event("navigation_click", { cpath, to: linkName, place });
    trackFBEvent(linkName, `${place}_click`);
};

export const gaMobileMenu = (event: "open" | "close", cpath: string) => {
    trackGA4Event(`${event}_mobile_menu`, { cpath });
    trackFBEvent(`${event}_mobile_menu`, "mobile_menu");
};

const storeLinkActionMap = {
    ios: "app_store",
    android: "google_play",
    huawei: "huawei_store",
    get_app_button: "get_app_button",
    intro_button: "intro_button",
    in_article_conversion_link: "in_article_conversion_link",
};
export const gaConversionLinkClick = (
    kind:
        | AppPlatform
        | "get_app_button"
        | "in_article_conversion_link"
        | "intro_button",
    cpath: string,
    to: string,
    place?: string,
) => {
    trackGA4Event(`store_click`, {
        cpath,
        to,
        lbl: storeLinkActionMap[kind],
        place,
    });
    trackFBEvent(
        `${storeLinkActionMap[kind]}_click`,
        `${cpath}:to:${to}${place ? `:sc:${place}` : ""}`,
        "ecommerce",
    );
};

export const gaCookieConsent = (
    action: "accept" | "learn_more",
    cpath: string,
) => {
    trackGA4Event(`cookie_consent_${action}_click`, { cpath });
    trackFBEvent(`cookie_consent_${action}_click`);
};

export const gaMarkdownLinkClick = (
    type: "internal" | "external" | "hash",
    to: string,
    cpath: string,
) => {
    trackGA4Event(`in_article_${type}_link_click`, { cpath, to });
    trackFBEvent(`in_article_${type}_link_click`, to);
};

export const gaShareClick = (
    socialMedia: SocialMedia,
    label: string,
    place: string,
    cpath: string,
) => {
    trackGA4Event("share_click", { cpath, to: socialMedia, lbl: label, place });
    trackFBEvent(`${place}_${socialMedia}_click`, label, "sharing");
};

export const gaSitemapClick = (link: string, cpath: string) => {
    trackGA4Event("sitemap_link_click", { cpath, to: link });
    trackFBEvent(`sitemap_link_click`, link);
};
export const gaSocialMediaLinkClick = (linkName: string, cpath: string) => {
    trackGA4Event("social_media_link_click", {
        cpath,
        to: linkName,
    });
    trackFBEvent(`social_link_${linkName}_click`);
};

export const gaExternalLinkClick = (
    to: string,
    cpath: string,
    place?: string,
) => {
    trackGA4Event(`external_link_click`, { cpath, to, place });
};
